var MODAL_KEYS = {
  TRIGGER_STEP: 'TRIGGER_STEP',
  SEARCH: 'SEARCH',
  ADD_NODE: 'ADD_NODE',
  SECOND_STEP_MODAL: 'SECOND_STEP_MODAL',
  CREATE_FLOW: 'CREATE_FLOW'
};
export default MODAL_KEYS;